<template>
  <div>
    <div class="row">
      <!-- Prefix -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('campaignDesigner.contentSelection.prefix')"
            :validation="['required']"
            ref="setting_prefix"
            v-if="editable"
            v-model="prefix" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.prefix')"
            :value="prefix"
            v-else />
        </div>
      </div>

      <!-- Sender -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('campaignDesigner.contentSelection.sender')"
            :validation="['required']"
            ref="setting_sender"
            v-if="editable"
            v-model="sender" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.sender')"
            :value="sender"
            v-else />
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Message custom -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <TextArea
            :label="$t('campaignDesigner.contentSelection.messageCustom')"
            max-length="4000"
            ref="setting_messageCustom"
            required
            v-if="editable"
            v-model="messageCustom" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.messageCustom')"
            :value="messageCustom"
            v-else />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Input from '../../../../slds/Input'
import OutputField from '../../../../slds/OutputField'
import TextArea from '../../../../slds/TextArea'
import _ from 'lodash'
export default {
  components: {
    Input,
    OutputField,
    TextArea
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
      required: true
    },
    value: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data () {
    return {
      messageCustom: '',
      sender: '',
      prefix: ''
    }
  },
  methods: {
    getSectionToSave () {
      return {
        messageCustom: {
          selected: this.messageCustom
        },
        prefix: {
          selected: this.prefix
        },
        sender: {
          selected: this.sender
        }
      }
    },
    mapValue (value) {
      const {
        messageCustom,
        prefix,
        sender
      } = value

      this.messageCustom = messageCustom.selected,
      this.prefix = prefix.selected,
      this.sender = sender.selected
    },
    resetValidation () {
      Object.values(this.$refs).forEach(ref => {
        if (ref.clearValidationError) {
          ref.clearValidationError()
        }
      })
    },
    validate () {
      return Object.values(this.$refs)
        .flat()
        .map(r => r.validate())
        .every(v => !!v)
    }
  },
  activated () {
    this.resetValidation()
  },
  created () {
    this.mapValue(this.value)
  },
  watch: {
    value (value) {
      this.resetValidation()
      this.mapValue(value)
    }
  },
}
</script>
<style lang="scss" scoped>
  .full-height {
    height: 100%;
    overflow-y: auto;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .col {
    flex-grow: 1;
  }
</style>
